import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const GroupRequirementsFieldsetDescription = () =>
  <Paragraph>
    <strong>
      <Color variant='theme-description-text'>
        Requirement groups let you manage a set of requirements together, making it easier to manage changes. For example, you might have a separate requirement group for each system under test.
      </Color>
    </strong>
  </Paragraph>

export default GroupRequirementsFieldsetDescription
